import '/assets/styles/partials/pricebox.scss';
import { useMemo } from 'react';
import classNames from 'classnames';

import config from '@wearetla/tla-essentials-tools/config';

// Functions
import formatNumber from '@wearetla/tla-essentials-tools/functions/format-number';

const Pricebox = ({ price: priceProp, className }) => {
	const price = useMemo(() => {
		if (typeof priceProp === 'string') {
			return priceProp;
		} else if (typeof priceProp === 'number') {
			return formatNumber(priceProp);
		} else {
			return false;
		}
	}, [priceProp]);

	if (price) {
		return (
			<span className={classNames('pricebox', className)}>
				{price}
				<span className="pricebox-currency">{config.mainCurrency.name}</span>
			</span>
		);
	} else {
		return null;
	}
};

export default Pricebox;
